import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RadioButtonOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"radio_button_on"}/>
}
